<template>
    <div>
        <label class="v-label theme--light">{{ mylabel }}</label>
        <vue2-tinymce-editor 
            v-model="content" 
            :options="options" 
            @editorChange="change" 
            @editorInit="initEditor" 
            :key="refreshKey" 
            ref="te">
        </vue2-tinymce-editor>
    </div>
</template>

<script>

import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
    components: {
        Vue2TinymceEditor
    },
    props: {
        value: { type: String },
        readonly: { type: Boolean },
        label: { type: String }
    },
    mounted() {
        // #######################################################
        // Per ovviare a problemi della libreria dentro a v-dialog
        this.$refs.te.editor = {};
        this.$refs.te.editor.destroy = () => { return true; };
        setTimeout(() => {
            this.refreshKey += 1;
        }, 200);
        // #######################################################
    },
    data() {
        return {
            content: this.value,
            mylabel: this.label ? this.label : 'Message',
            refreshKey:0,
            options: {
                menubar: false,
                resize: false,
                readonly: this.readonly,
                plugins: 'lists advlist autolink charmap code codesample directionality link table',
                toolbar1: 'fontselect | fontsizeselect | formatselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | numlist bullist',
                toolbar2: 'outdent indent | table link removeformat | code'
            }
        };
    },
    methods: {
        change() {
            this.$emit('input', this.content.replace(/\n|\r/g, ""))
        },
        initEditor() {
        }
    },
};

</script>